import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-28d528d2")

_pushScopeId("data-v-28d528d2")
const _hoisted_1 = { class: "main-bg" }
const _hoisted_2 = { class: "opebtn" }
const _hoisted_3 = { class: "opebtn-left" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 选择操作")
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("管理模式设定")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("移除设备")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("转移复制车载设备")
const _hoisted_9 = { class: "opebtn-right" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("代导入车载设备")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_cascader = _resolveComponent("el-cascader")
  const _component_c_search_list = _resolveComponent("c-search-list")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_c_export_file = _resolveComponent("c-export-file")
  const _component_c_table = _resolveComponent("c-table")
  const _component_set_control_dialog = _resolveComponent("set-control-dialog")
  const _component_import_dialog = _resolveComponent("import-dialog")
  const _directive_hasAuth = _resolveDirective("hasAuth")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_c_search_list, {
      inputList: _ctx.inputList,
      showNumber: 5,
      onOnSearch: _ctx.handleSearch,
      onOnReset: _ctx.handleReset
    }, {
      deviceMaintainUuid: _withId((data) => [
        _createVNode(_component_el_cascader, {
          modelValue: data.formData[data.key],
          "onUpdate:modelValue": ($event: any) => (data.formData[data.key] = $event),
          props: _ctx.cascaderProps,
          clearable: ""
        }, null, 8, ["modelValue", "onUpdate:modelValue", "props"])
      ]),
      _: 1
    }, 8, ["inputList", "onOnSearch", "onOnReset"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_dropdown, { onCommand: _ctx.handleCommand }, {
          dropdown: _withId(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withId(() => [
                _withDirectives(_createVNode(_component_el_dropdown_item, {
                  command: "setMode",
                  disabled: !_ctx.multipleSelection.length
                }, {
                  default: _withId(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["disabled"]), [
                  [_directive_hasAuth, 'vehicle-device-management-setMode']
                ]),
                _withDirectives(_createVNode(_component_el_dropdown_item, {
                  command: "remove",
                  disabled: !_ctx.multipleSelection.length
                }, {
                  default: _withId(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["disabled"]), [
                  [_directive_hasAuth, 'vehicle-device-management-remove']
                ])
              ]),
              _: 1
            })
          ]),
          default: _withId(() => [
            _createVNode(_component_el_button, { type: "primary" }, {
              default: _withId(() => [
                _hoisted_4,
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onCommand"]),
        _withDirectives(_createVNode(_component_el_button, {
          type: "primary",
          class: "transfer-btn",
          onClick: _ctx.handleTransfer
        }, {
          default: _withId(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onClick"]), [
          [_directive_hasAuth, 'vehicle-device-management-transfer']
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _withDirectives(_createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleImport
        }, {
          default: _withId(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["onClick"]), [
          [_directive_hasAuth, 'vehicle-device-management-import']
        ]),
        _withDirectives(_createVNode(_component_c_export_file, {
          url: "/device/terminal/export",
          params: _ctx.queryForm,
          "btn-text": "导出查询内容",
          "file-title": _ctx.exportFileName
        }, null, 8, ["params", "file-title"]), [
          [_directive_hasAuth, 'vehicle-device-management-export']
        ])
      ])
    ]),
    _createVNode(_component_c_table, {
      class: "mt10",
      dataSource: _ctx.tableConfig,
      onPageCurrentChange: _ctx.pageCurrentChange,
      onPageSizeChange: _ctx.pageSizeChange,
      onSelectionChange: _ctx.selectionChange
    }, {
      controlMode: _withId((scope) => [
        _createTextVNode(_toDisplayString(_ctx.controlModeEnum[scope.row.controlMode] || '-'), 1)
      ]),
      effectiveDate: _withId((scope) => [
        _createTextVNode(_toDisplayString(scope.row.effectiveStartTime) + " - " + _toDisplayString(scope.row.effectiveEndTime), 1)
      ]),
      _: 1
    }, 8, ["dataSource", "onPageCurrentChange", "onPageSizeChange", "onSelectionChange"]),
    (_ctx.visible)
      ? (_openBlock(), _createBlock(_component_set_control_dialog, {
          key: 0,
          modelValue: _ctx.visible,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = $event)),
          ids: _ctx.setModeIds,
          onRefreshList: _ctx.getListFn
        }, null, 8, ["modelValue", "ids", "onRefreshList"]))
      : _createCommentVNode("", true),
    (_ctx.importVisible)
      ? (_openBlock(), _createBlock(_component_import_dialog, {
          key: 1,
          modelValue: _ctx.importVisible,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.importVisible = $event)),
          onRefreshList: _ctx.getListFn
        }, null, 8, ["modelValue", "onRefreshList"]))
      : _createCommentVNode("", true)
  ]))
})